import { Editor } from '@tiptap/react';
import { TFunction } from 'i18next';

export type ActionType = {
  type: 'format' | 'link';
  execute: (editor: Editor) => void;
};

type MenuItemConfig = {
  icon: string;
  label: string;
  action: ActionType;
  isActive: (editor: Editor) => boolean;
};

type MenuConfig = {
  formatting: MenuItemConfig[];
  lists: MenuItemConfig[];
  links: MenuItemConfig[];
};

export const BubbleMenuConfig = (t: TFunction<string>): MenuConfig => ({
  formatting: [
    {
      icon: 'mingcute:bold-line',
      label: t('bold'),
      action: {
        type: 'format',
        execute: (editor) => editor.chain().focus().toggleBold().run(),
      },
      isActive: (editor) => editor.isActive('bold'),
    },
    {
      icon: 'mingcute:italic-line',
      label: t('italic'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleItalic().run(),
      },
      isActive: (editor) => editor.isActive('italic'),
    },
    {
      icon: 'mingcute:underline-line',
      label: t('underline'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleUnderline().run(),
      },
      isActive: (editor) => editor.isActive('underline'),
    },
    {
      icon: 'mingcute:strikethrough-line',
      label: t('strike'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleStrike().run(),
      },
      isActive: (editor) => editor.isActive('strike'),
    },
  ],
  lists: [
    {
      icon: 'mingcute:list-check-line',
      label: t('bullet_list'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleBulletList().run(),
      },
      isActive: (editor) => editor.isActive('bulletList'),
    },
    {
      icon: 'mingcute:list-ordered-line',
      label: 'Ordered List',
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleOrderedList().run(),
      },
      isActive: (editor) => editor.isActive('orderedList'),
    },
  ],
  links: [
    {
      icon: 'mingcute:link-line',
      label: t('link'),
      action: {
        type: 'link',
        execute: () => {},
      },
      isActive: (editor) => editor.isActive('link'),
    },
  ],
});
